import React from 'react'

const Trabajos = () => (
  <section className="section">
    <h2>Nuestros Trabajos</h2>
    <div className="tarjetas">
      <div className="tarjeta">
        <h3>Proyecto Industrial</h3>
        <p>Diseño y ejecución de planta manufacturera de 5,000 m².</p>
      </div>
      <div className="tarjeta">
        <h3>Construcción Civil</h3>
        <p>Supervisión de obra residencial con certificación energética.</p>
      </div>
      <div className="tarjeta">
        <h3>Automatización</h3>
        <p>Sistemas de automatización para líneas de producción industrial.</p>
      </div>
    </div>
  </section>
)

export default Trabajos